import { ReactElement } from 'react';

import { BitbucketLogo } from '@atlaskit/logo';
import { token } from '@atlaskit/tokens';

const BitbucketPrideLogo = (): ReactElement => {
  return (
    <div
      style={{
        borderRadius: '5px',
        padding: '5px',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        background:
          // eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage
          'linear-gradient(135deg, #FF5623 16.66%, #FF8C00 16.66%, 33.33%, #FFAB00 33.33%, 50%, #2DB57D 50%, 66.66%, #00B8D9 66.66%, 83.33%, #8777D9 83.33%)',
      }}
    >
      <BitbucketLogo iconColor={token('color.text.inverse')} size="small" />
    </div>
  );
};

export default BitbucketPrideLogo;
